import { driver } from "driver.js";
import "driver.js/dist/driver.css";

export function startTourCompartirPerfil(navigate, uid) {
  const profilePath = `/perfil/${uid}`;

  if (window.location.pathname === profilePath) {
    setTimeout(() => startCompartirPerfilTourSteps(), 400);
  } else {
    sessionStorage.setItem("aw_pending_tour", "compartir-perfil");
    navigate(profilePath);
  }
}

export function startCompartirPerfilTourSteps() {
  let menuClickHandler = null;
  let optionClickHandler = null;

  const cleanupMenuListener = () => {
    const btn = document.querySelector('[data-tour-id="perfil-menu-trigger"]');
    if (btn && menuClickHandler) {
      btn.removeEventListener("click", menuClickHandler);
      menuClickHandler = null;
    }
  };

  const cleanupOptionListener = () => {
    const opt = document.querySelector('[data-tour-id="menu-compartir-perfil"]');
    if (opt && optionClickHandler) {
      opt.removeEventListener("click", optionClickHandler);
      optionClickHandler = null;
    }
  };

  const driverObj = driver({
    showProgress: true,
    nextBtnText: "Siguiente →",
    prevBtnText: "← Anterior",
    doneBtnText: "¡Listo!",
    progressText: "{{current}} de {{total}}",
    allowClose: false,
    onDestroyStarted: () => {
      cleanupMenuListener();
      cleanupOptionListener();
      driverObj.destroy();
    },
    steps: [
      {
        element: '[data-tour-id="perfil-menu-trigger"]',
        popover: {
          title: "⋯ Menú de opciones",
          description:
            "Haz clic en este botón para abrir el menú de opciones de tu perfil.",
          side: "bottom",
          align: "end",
          showButtons: ["close"],
        },
        onHighlightStarted: () => {
          const btn = document.querySelector('[data-tour-id="perfil-menu-trigger"]');
          if (!btn) return;
          menuClickHandler = () => {
            cleanupMenuListener();
            setTimeout(() => driverObj.moveNext(), 400);
          };
          btn.addEventListener("click", menuClickHandler);
        },
        onDeselected: () => {
          cleanupMenuListener();
        },
      },
      {
        element: '[data-tour-id="menu-compartir-perfil"]',
        popover: {
          title: "🔗 Compartir tu Perfil",
          description:
            "Haz clic aquí para compartir el enlace de tu perfil público con amigos y en tus redes sociales.",
          side: "left",
          align: "start",
          showButtons: ["close"],
        },
        onHighlightStarted: () => {
          const opt = document.querySelector('[data-tour-id="menu-compartir-perfil"]');
          if (!opt) return;
          optionClickHandler = () => {
            cleanupOptionListener();
            driverObj.destroy();
          };
          opt.addEventListener("click", optionClickHandler);
        },
        onDeselected: () => {
          cleanupOptionListener();
        },
      },
    ],
  });

  driverObj.drive();
}
